module.exports = __webpack_public_path__ + "images/feature/20170915-1-2396cc7d29f0ea8ac8fa44ab49603b88.jpg";